<template>
  <v-app-bar prominent class="main-navbar">
    <v-app-bar-nav-icon id="burger-menu" style="color:#ffffff;" variant="text" @click.stop="drawer = !drawer"/>

    <router-link :to="`${store.getters.getRouterBaseURL}/`" id="onkopus-logo">
        <img src="@/assets/onkopus_logo_v0.1.4.2_640.png" width="60"
            style="margin-right: 20px; margin-left: 10px;padding:2px;"
            class="start-logo"
            />
    </router-link>

    <router-link class="onkopus-title" :to="`${store.getters.getRouterBaseURL}/`" id="onkopus-title">
      Onkopus
      <!--<span style="margin-left:20px;font-size:18px;">v0.0.1</span>-->
    </router-link>

    <router-link style="text-decoration: none; text-align:center" :to="`${store.getters.getRouterBaseURL}/upload`">
      <div class="nav-bar-btn" :class="{ 'nav-bar-btn-selected': active_route == 'upload' }">
        Search
      </div>
    </router-link>

    <router-link style="text-decoration: none;" :to="`${store.getters.getRouterBaseURL}/mtb/get-ids`"
      v-if="store.getters.get_devmode">
      <div class="nav-bar-btn" :class="{ 'nav-bar-btn-selected': active_route == 'mtb' }">
        MTB
      </div>
    </router-link>

    <router-link style="text-decoration: none;" :to="`${store.getters.getRouterBaseURL}/about`">
      <div class="nav-bar-btn" :class="{ 'nav-bar-btn-selected': active_route == 'about' }">
        Getting started
      </div>
    </router-link>

    <router-link style="text-decoration: none;" :to="`${store.getters.getRouterBaseURL}/docs`">
      <div class="nav-bar-btn" :class="{ 'nav-bar-btn-selected': active_route == 'docs' }">
        Documentation
      </div>
    </router-link>

    <router-link style="text-decoration: none;" :to="`${store.getters.getRouterBaseURL}/api`">
      <div class="nav-bar-btn" :class="{ 'nav-bar-btn-selected': active_route == 'api' }">
        API
      </div>
    </router-link>

    <router-link style="text-decoration: none;" :to="`${store.getters.getRouterBaseURL}/contact`">
      <div class="nav-bar-btn" :class="{ 'nav-bar-btn-selected': active_route == 'contact' }">
        About
      </div>
    </router-link>

    <div style="width:220px;height:65px;padding-left:20px;">
        <v-text-field v-model="q" prepend-inner-icon="mdi-magnify" base-color="#ffffff" color="#ffffff" @keyup.enter="startNavBarSearch()"
            style="color:#ffffff;"
        >

        </v-text-field>
    </div>

  </v-app-bar>

  <v-navigation-drawer v-model="drawer" bottom temporary>

    <v-list>
      <v-list-item v-for="item in items" :key="item.title">
        <router-link style="text-decoration: none;" :to="`${store.getters.getRouterBaseURL}${item.value}`"
        v-if="item.title.toLowerCase() != 'mtb' || store.getters.get_devmode">
          {{item.title}}
        </router-link>
      </v-list-item>
    </v-list>

  </v-navigation-drawer>

</template>
<script setup lang="js">

import { ref, watch, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

const route = useRoute();
const store = useStore();
const router = useRouter();

const drawer = ref(false);
const active_route = ref('');
const items = ref([
  {
    title: 'Search',
    value: '/upload',
  },
  {
    title: 'MTB',
    value: '/mtb/get-ids',
  },
  {
    title: 'About',
    value: '/about',
  },
  {
    title: 'Documentation',
    value: '/docs',
  },
  {
    title: 'Contact',
    value: '/contact',
  },

]);

let q=''

defineExpose(q)

function startNavBarSearch() {
            store.dispatch('clearAGG');

            store.dispatch('setSNVs',{})
            store.dispatch('setIns',{})
            store.dispatch('setDels',{})
            store.dispatch('setCNVs',{})
            store.dispatch('setFusions',{})

            store.dispatch('setProcessState', [  "load-results",'<table><tr><td><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></td></tr><tr><td>Loading...</td></tr></table>' ] )

            router.push( store.getters.getRouterBaseURL + '/upload/show-variant-interpretation-results-q?q='+ q + '&genome_version=' + store.getters.getGenomeVersion)
            store.dispatch('setProcessState',['load-results',''])
        }

onMounted(() => {
  var split_route = route.path.split("/");
  active_route.value = split_route[1];
})

watch(() => route.path, (to) => {
  var split_route = to.split("/");
  active_route.value = split_route[1];
});

</script>

<style scoped>

.main-navbar {
  background-image: var(--default-gradient) !important;
  /*background-color: var(--dark-blue);*/
  /*background: url(require('@/assets/navbar_v0.1.png')) center top repeat-x;*/
  /*background-image: url('@/assets/onkopus_navbar_v0.2.png') left top repeat-x repeat-y !important;*/
  font-size:18px;
}

.onkopus-title {
  display: flex;
  align-items: center;
  height: 64px;
  text-decoration: none;
  margin-right: 20px;
  color: white;
  font-size: 26px;
}

.bm-burger-button {
  position: fixed;
  width: 36px;
  height: 30px;
  left: 36px;
  top: 36px;
  cursor: pointer;
}

.bm-burger-bars {
  background-color: #e3e3e3;
}

.bm-overlay {
  background: rgba(0, 0, 0, 0.3);
}

.bm-item-list {
  color: #b8b7ad;
  margin-left: 10%;
  font-size: 20px;
}

.bm-item-list>* {
  display: flex;
  text-decoration: none;
  padding: 0.7em;
}

.bm-item-list>*>span {
  margin-left: 10px;
  font-weight: 700;
  color: white;
}

.nav-bar-btn {
  display: flex;
  height: 40px;
  align-items: center;
  justify-items: center;
  margin-right: 20px;
  margin-left: 20px;
  font-size: var(--font-800);
  padding-top: 10px;
  color: white;
  display: none;
}

.nav-bar-btn:hover {
  color: var(--light-grey);
}

.nav-bar-btn-selected {
  border-bottom: 2px solid white !important;
}

.nav-bar-btn-selected:hover {
  color: white;
}


@media screen and (min-width: 900px) {

#burger-menu { display: none;}

.nav-bar-btn {
  display: block;
  font-size:18px;
}

}

.start-logo {
    border-radius: 50%;
    /*min-height: 500px;
    min-width: 500px;*/
    background-color:#ffffff;
}

.start-logo:hover {
    background-color:#4d4d4d;
}

</style>